import { useState } from "react";
import { Modal } from "react-bootstrap";
import CustomerTab from "../ShipmentContentLayout/CustomerTab";

export default function CustomerSelectModal({
  shipment,
  selectedCustomer,
  handleCustomerSelect,
  refreshShipment,
  activeFilter,
  setActiveFilter,
}) {
  /*   All States
   ********************************************* */
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showCusAdvanceForm, setShowCusAdvanceForm] = useState(false);

  /*   All Functions
   ********************************************* */

  const onCustomerSelect = (customer) => {
    handleCustomerSelect(customer);
    setShowCustomerModal(false);
  };

  /*   All UseEffects
   ********************************************* */
  return (
    <div>
      <button
        onClick={(e) => {
          setShowCustomerModal(true);
        }}
        className="btn btn-sm btn-primary me-3"
      >
        Select Customer
      </button>
      <Modal
        show={showCustomerModal}
        onHide={() => setShowCustomerModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomerTab
            shipment={shipment}
            activeFilter={activeFilter || "processing"}
            setActiveFilter={setActiveFilter}
            showCusAdvanceForm={showCusAdvanceForm}
            setShowCusAdvanceForm={setShowCusAdvanceForm}
            selectedCustomer={selectedCustomer}
            onCustomerSelect={onCustomerSelect}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
